import { render, staticRenderFns } from "./FormPostcodeAdditionalFee.vue?vue&type=template&id=25999973&scoped=true&"
import script from "./FormPostcodeAdditionalFee.vue?vue&type=script&lang=js&"
export * from "./FormPostcodeAdditionalFee.vue?vue&type=script&lang=js&"
import style0 from "./FormPostcodeAdditionalFee.vue?vue&type=style&index=0&id=25999973&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25999973",
  null
  
)

export default component.exports